const idle = 'idle';
const pending = 'pending';
const loading = 'loading';
const fulfilled = 'fulfilled';
const rejected = 'rejected';

export { idle, fulfilled, loading, pending, rejected };
